<template>
  <form class="centered-container" v-if="!status.loggedIn" @submit.prevent="handleSubmit">
    <md-content class="md-elevation-3">
      <div class="title">
        <div class="md-title">{{ $t('heading.loginPage') }}</div>
      </div>
      <div class="form">
        <md-field>
          <label>{{ $t('label.username') }}</label>
          <md-input v-model="username" autofocus></md-input>
        </md-field>
        <div class="invalid-field" v-if="submitted && !username">{{ $t('label.usernameIsRequired') }}</div>
        <md-field md-has-password>
          <label>{{ $t('label.password') }}</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <div class="invalid-field" v-if="submitted && !password">{{ $t('label.passwordIsRequired') }}</div>
      </div>
      <div class="actions md-layout md-alignment-center-space-between">
        <md-button type="submit" class="md-raised md-primary" :disabled="status.loggingIn">{{ $t('label.login') }}</md-button>
      </div>
    </md-content>
  </form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LoginPage',
  data: () => ({
    username: '',
    password: '',
    submitted: false,
    loading: false
  }),
  computed: {
    ...mapState('account', ['status'])
  },
  methods: {
    ...mapActions('account', ['login']),
    handleSubmit (e) {
      this.submitted = true
      this.loading = false
      const { username, password } = this
      if (username && password) {
        this.login({ username, password })
      }
    }
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  margin-bottom: 30px;
}
.title img {
  margin-bottom: 16px;
  max-width: 80px;
}
.actions .md-button {
  margin: 0;
}
.form {
  margin-bottom: 60px;
}
.md-content {
  z-index: 1;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  position: relative;
}
.invalid-field {
  color: #800;
  text-align: left;
}
</style>
